import { isMaskedPhoneCountry } from '@Constants';

/*
 * `national` is the value the server stored for this number (`phone_national`). Outside US/CA we
 * show it when the record carries one, and the plain digits when it does not — the browser has no
 * phone library of its own, so it never builds a shape.
 */
function formatPhoneNumber(value: string, national?: string | null) {
  // Returns phone number in the format (123)456-7890
  // Appends 1 if passed in
  // TODO: how to format international numbers with more than 11 digits

  if (!value) return;

  const cleaned = ('' + value).replace(/\D/g, '');

  // NOTE :: Outside US/CA the US shapes below would mangle the number.
  if (!isMaskedPhoneCountry()) return national || cleaned || value;

  let match;

  if (cleaned.length === 7) {
    match = cleaned.match(/^(\d{3})(\d{4})$/);
    if (match) return `${match[1]}-${match[2]}`;
  } else if (cleaned.length === 9) {
    match = cleaned.match(/^(\d{3})(\d{3})(\d{3})$/);
    if (match) return `(${match[1]}) ${match[2]}-${match[3]}`;
  } else if (cleaned.length === 10) {
    match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) return `(${match[1]}) ${match[2]}-${match[3]}`;
  } else if (cleaned.length > 10 && cleaned.length <= 13) {
    const countryLen = cleaned.length - 10;
    const re = new RegExp(`^(\\d{${countryLen}})(\\d{3})(\\d{3})(\\d{4})$`);
    match = cleaned.match(re);
    if (match) {
      return `${match[1]}(${match[2]}) ${match[3]}-${match[4]}`;
    }
  }

  return value;
}

function getPhoneLastFourDigits(phone: string): string {
  const digits = String(phone || '').replace(/\D/g, '');
  if (digits.length < 4) return digits || '----';

  return digits.slice(-4);
}

function formatPhoneMaskedLastFour(phone: string): string {
  const lastFour = getPhoneLastFourDigits(phone);
  if (!lastFour || lastFour === '----') return '';

  return `(**) ***-${lastFour}`;
}

export { formatPhoneNumber, formatPhoneMaskedLastFour, getPhoneLastFourDigits };
